<template>
  <AppTextField
    v-model="model"
    v-bind="attrs"
    prepend-inner-icon="mdi-magnify"
    :hide-details="hideDetails"
    :placeholder="placeholder"
  />
</template>

<script setup lang="ts">
import { useAttrs } from "vue";
import AppTextField from "@/shared/components/ui/AppTextField.vue";

defineOptions({
  inheritAttrs: false,
});

const model = defineModel<string>({ default: "" });

withDefaults(
  defineProps<{
    placeholder?: string;
    hideDetails?: boolean | "auto";
  }>(),
  {
    placeholder: "Search...",
    hideDetails: true,
  },
);

const attrs = useAttrs();
</script>

